<template>
    <div class="position-relative p-0 map-div">

        <div class="bg-custom" style="position: absolute; min-width: 170px; top: 0rem; left: 0rem; padding: .25rem .75rem; z-index: 2; width: 100%;">
            <span class="float-start me-2 bg-dark1 text-light p-1">
                <NavbarButton :theme="G.theme" />
            </span>

            <div class="dropdown-center dropdown me-2 float-start">

                <a class="btn btn-dark w-1001 text-start" style="width: 200px;" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-chevron-down me-2 text-primary"></i>
                    <span>{{ comboFilter }}</span>
                </a>

                <ul class="dropdown-menu bg-dark1 w-100 map-filter">
                    <li>
                        <a class="dropdown-item" href="#" @click="getAllDevicePositions()">
                            <i class="fas fa-map-marked-alt me-3 text-primary"></i>{{constComboLabel}}
                        </a>
                    </li>
                    <li>
                        <hr class="dropdown-divider" />
                    </li>
                    <li v-for="(item, index) in cars" :key="index">
                        <a class="dropdown-item" href="#" @click="getPositionsByDeviceID(item)">
                            <i class="fas fa-map-pin me-3 text-primary"></i>{{ item.car_name }}
                        </a>
                    </li>
                </ul>
                    <!-- <li><a class="dropdown-item" href="#" @click="getPositionsByDeviceID(2)"><i class="fas fa-map-pin me-3"></i>Maral 002</a></li> -->
                <!-- <Dropdown
                    v-model="selectedDevice"
                    :options='cars'
                    optionValue="device_id"
                    optionLabel="car_name"
                    placeholder="select"
                    class="p-0 bg-dark1 text-light"
                    style="width: 520px;"
                    :showClear="true"
                    @change="test"
                >
                    <template #value="slotProps">
                        <div
                            v-if="slotProps.device_id"
                        >{{cars.filter((e) => e.device_id == slotProps.device_id)[0].car_name}}</div>
                        <span v-else>{{slotProps.placeholder}}</span>
                    </template>
                    <template #option="slotProps">
                        <div
                        >{{slotProps.option.car_name}}</div>
                    </template>
                </Dropdown> -->

            </div>

            <div class="float-start">
                <div class="input-group">
                    <DatePicker v-model="datepicker_start" dateFormat="dd.mm.yy" selectionMode="single" :showButtonBar="true" class="calendarRange" :stepMinute="5" :showSeconds="false" :showTime="true" placeholder="Zaman intervalı" :hideOnRangeSelection="true" />

                    <DatePicker v-model="datepicker_end" dateFormat="dd.mm.yy" selectionMode="single" :showButtonBar="true" class="calendarRange" :stepMinute="5" :showSeconds="false" :showTime="true" placeholder="Zaman intervalı" :hideOnRangeSelection="true" />

                    <button class="btn btn-primary" type="button" @click="getPositionByDateInterval()"><i class="fas fa-eye"></i></button>

                    <!-- <button class="btn btn-secondary ms-2" type="button" @click="selectedDevice = 0, datepicker='', getCurrentPositions()">Bütün zamanlar</button> -->
                </div>
            </div>
        </div>

        <div id="map" style="width: calc(100% - 0px); height: calc(100vh - 0px);"></div>

        <div id="popup">
            <!-- <div id="popup-content"></div> -->
        </div>

        <!-- Detail info window -->
        <div class="p-sm-3 bg-white mt-1 rounded position-absolute device-info"
            :class="showDetailInfo ? 'd-block' : 'd-none'" style="z-index: 999;">
            <div class="cursor-pointer" @click="showDetailInfoBody = !showDetailInfoBody">
                <strong>{{ pointDetails.device != null ? pointDetails.device.car_name : '' }}</strong>
                <span v-if="!showDetailInfoBody" class="float-start"><i class="fas fa-info-circle fs-6 me-3"></i>{{infoTitle}}</span>
                <span class="float-end px-2 py-1 ms-2" @click="showDetailInfo = !showDetailInfo;"><i class="fas fa-times fs-6"></i></span>
                <span class="float-end px-2 py-1"><i class="fas fs-6" :class="showDetailInfoBody ? 'fa-chevron-down' : 'fa-chevron-up'"></i></span>
            </div>

            <nav :class="showDetailInfoBody ? 'd-block mt-2' : 'd-none'">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home"
                        type="button" role="tab" aria-controls="nav-home" aria-selected="true">Məkanlar</button>
                    <button v-if="pointDetails.device != null" class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile"
                        type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Cihaz məlumatı</button>
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent" :class="showDetailInfoBody ? 'd-block' : 'd-none'">
                <div class="tab-pane fade show active" style="max-height: 200px;overflow: auto;" id="nav-home"
                    role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
                    <table class="table table-light table-hover table-bordered m-0">
                        <thead class="table-secondary">
                            <tr>
                                <th scope="col">#</th>
                                <template v-for="(item, index) in pointDetails.points[0]" :key="index">
                                    <th scope="col">{{TR[index]}}</th>
                                </template>
                                <!--
                                <th scope="col">Adı</th>
                                <th scope="col">Heyvan növü</th>
                                <th scope="col">Park</th>
                                <th scope="col">Tarix</th>
                                <th scope="col">Longitude</th>
                                <th scope="col">Latitude</th> -->
                                <!-- <th scope="col">Sürət</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in pointDetails.points" :key="index" class="cursor-pointer"
                                @click="viewPoint(item)">
                                <th scope="row">{{ index + 1 }}</th>
                                <template v-for="(item1, ind1) in item" :key="ind1">
                                    <td>{{item1}}</td>
                                </template>
                                <!-- <td>{{ item.car_name }}</td>
                                <td>{{ item.car_type }}</td>
                                <td>{{ item.zone_name }}</td>
                                <td>{{ item.gps_date }}</td>
                                <td>{{ item.lon }}</td>
                                <td>{{ item.lat }}</td> -->

                                <!-- <td>{{ item.speed }}</td> -->
                            </tr>
                        </tbody>

                    </table>
                </div>
                <div class="tab-pane fade" style="max-height: 200px;overflow: auto;"  id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab" tabindex="0">
                    <table class="table table-light table-hover table-bordered m-0">
                        <thead class="table-secondary">
                            <tr>
                                <th scope="col">Cihaz adı</th>
                                <th scope="col">IMEI</th>
                                <!-- <th scope="col">Tel / Mob</th> -->
                                <th scope="col">Cihazın istifadə müddəti (gün)</th>
                                <th scope="col">Dəyişmə vaxtına (qaldı)</th>
                            </tr>
                        </thead>
                        <tbody v-if="pointDetails.device">
                            <!-- <tr v-if="pointDetails.device.car_name"> -->
                            <tr v-for="(item, index) in pointDetails.device" :key="index">
                                <td>{{ item.device_name }}</td>
                                <td>{{ item.imei }}</td>
                                <!-- <td>{{ item.phone }}</td> -->
                                <td>{{ item.battery_lifetime }}</td>
                                <td>{{ item.lifetime_end }}</td>
                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>
        </div>

        <!-- Map Toolbar buttons -->
        <div class="dropdown ot-map-toolbar">
            <div :class="!dt_toolbar_buttons.extool ? 'd-none' : 'd-block'" class="eToolCol">
                <button class="" :class="dt_toolbar_buttons.flash ? 'active' : '' " type="button" aria-expanded="false" @click="DT_flashLastPoint" title="Son nöqtəni göstər">
                    <i class="fas fa-map-marker-alt"></i>
                </button>
                <button class="" :class="dt_toolbar_buttons.label ? 'active' : '' " type="button" aria-expanded="false" @click="DT_showLabels" title="Adları göstər">
                    <i class="fas fa-tag"></i>
                </button>
                <button class="" type="button" aria-expanded="false" @click="DT_fullView" title="Xəritəni tam göstər">
                    <i class="fas fa-expand"></i>
                </button>
                <button class="" :class="dt_toolbar_buttons.customer ? 'active' : '' " type="button" aria-expanded="false" @click="DT_customerView" title="Müştəriləri göstər">
                    <i class="fas fa-store"></i>
                </button>
                <div>
                    <button class="dropup" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Alt xəritəni dəyiş">
                        <i class="fas fa-globe"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end">
                        <li v-for="(item, index) in basemapsLabel" :key="index">
                            <a class="dropdown-item" @click="changeBasemap(index)"><img :src="`/assets/images/basemaps/${index}.png`" class="rounded me-1" style="width: 30px;" /> {{item}} </a>
                        </li>
                    </ul>
                </div>
                <button class="" type="button" aria-expanded="false" @click="DT_clearMap" title="Təmizlə">
                    <i class="fas fa-trash-alt"></i>
                </button>
            </div>
            <div>
                <button class="" :class="dt_toolbar_buttons.extool ? 'active' : '' " type="button" aria-expanded="false" @click="DT_exToolView" title="Buttons show">
                    <i class="fas" :class="dt_toolbar_buttons.extool ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </button>
            </div>
        </div>

        <!-- Footer info panel -->
        <div class="rounded1 position-absolute footer-info bg-custom text-light px-4">
            <div class="row">
                <div class="col col-md-2 col-sm-12">
                    <span id="mouse_position"></span>
                </div>
                <div class="col col-md-2 col-sm-12 d-flex-inline align-self-center d-none d-sm-block">
                    <span id="map_scale"></span>
                </div>
                <div v-if="lineLength" class="col fs-6 text-light d-none d-sm-block p-0">
                    {{ TR.total }}: <span class="ms-2">{{ lineLength }}</span>
                </div>
                <div class="col text-end fs-7 text-light footer-powered" v-html="G.footerPowered"></div>
            </div>
        </div>


    </div>
    <!-- <div ref="maproot" style="width: calc( 100vw - 280px ); height: calc( 100vh - 123px );"></div> -->
</template>

<script>
import { ref, reactive, onMounted, watchEffect, onUnmounted } from "vue";

// import moment from 'moment';

import "ol/ol.css";

import View from "ol/View";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";

import Overlay from "ol/Overlay";
// import Feature from "ol/Feature";
// import { Point, MultiLineString, LineString } from "ol/geom.js";
import { Point } from "ol/geom.js";
import { Circle as CircleStyle, Fill, Stroke, Style, Text, Icon } from "ol/style.js";

// import {getLength} from 'ol/sphere.js';

import { easeOut } from 'ol/easing.js';
import { getVectorContext } from 'ol/render.js';
import {unByKey} from 'ol/Observable.js';

// import OSM from "ol/source/OSM";
// import XYZ from "ol/source/XYZ";
import VectorSource from "ol/source/Vector";
// import { Cluster, XYZ } from "ol/source";
import { XYZ } from "ol/source";

// import { WKT, GeoJSON } from "ol/format";
// import { GeoJSON } from "ol/format";

// import * as olProj from "ol/proj";
// import { fromLonLat, toLonLat, transform, useGeographic } from "ol/proj.js";
import { useGeographic } from "ol/proj.js";
// import { toStringHDMS } from "ol/coordinate.js";

// import Select from 'ol/interaction/Select.js';
// import {click} from 'ol/events/condition.js';
// import MousePosition from 'ol/control/MousePosition.js';
import {ScaleLine, defaults as defaultControls} from 'ol/control.js';
// import {createStringXY} from 'ol/coordinate.js';

import DatePicker from 'primevue/datepicker';

// import proj4 from 'proj4';
// import {get as getProjection} from 'ol/proj.js';
// import {register} from 'ol/proj/proj4.js';

import NavbarButton from "@/components/navbar/NavbarButton";

import { useStore } from "@/store";
// import { G, ajax } from '@/_common';
import { G } from '@/_common';


export default {
    title: "Xəritə",
    name: "MapP",
    components: {
        DatePicker,
        NavbarButton,
    },
    setup() {
        const store = useStore();

        const olMap = ref(null);
        const customerLayer = ref(null);
        const vectorLayer = ref(null);
        const vectorCurPosLayer = ref(null);
        const vectorLayerLine = ref(null);

        const popup = ref();
        const popover = ref();

        const showDetailInfo = ref(false);
        const showDetailInfoBody = ref(true);

        const cars = ref([]);
        const pointDetails = ref({
            "device": {},
            "points": []
        });

        const dt_toolbar_buttons = reactive({
            "flash": true,
            "label": false,
            "customer": false,
            "extool": false,
        });

        const selectedDevice = ref({});
        const carColor = {};
        const styleCache = {};
        const styleCacheCur = {};
        const listenerKey = {};
        const infoTitle = ref('');

        // const datepicker = ref(''); // ref( moment(new Date()).format('DD.MM.YYYY hh:mm') );
        // const datepicker_start = ref( dayjs().set('hour', 0).set('minute', 1).format('DD.MM.YYYY HH:mm') );

        const datepicker_start = ref();
        const datepicker_end = ref();
        // const datepicker_start = ref( dayjs().hour(0).minute(0).second(0).toDate() );
        // const datepicker_end = ref( dayjs().toDate() );

        // const datepicker_end = ref( new Date(moment(new Date(), 'DD.MM.YYYY 00:00')) );
        // const flashfeature = ref(null);
        const curposinterval = ref(null);

        const constComboLabel = 'Bütün cihazlar';
        const comboFilter = ref(constComboLabel);

        // const lastSelectedFeature = ref(null);
        const firstLastFeatureId = ref(null);

        const TR = ref({});

        const basemapsLabel = {
            "none": "Boş",
            "G_STREET": "Google Street",
            "G_SATELLITE": "Google Satellite",
            "G_TERRAIN": "Google Terrain",
            // "G_TERRAIN2": "Google Terrain 2",
            "G_ROADMAP": "Google Roadmap",
            "G_HYBRID": "Google Hybrid",
        };

        const basemaps = {
            "none": "",
            "G_STREET": "//mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}&hl=az", // G_STREET
            "G_SATELLITE": "//mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}&hl=az", // G_SATELLITE
            "G_TERRAIN": "//mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}&hl=az", // G_TERRAIN
            // "G_TERRAIN2": "//mt1.google.com/vt/lyrs=t&x={x}&y={y}&z={z}&hl=az", // G_TERRAIN2
            "G_ROADMAP": "//mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=az", // G_ROADMAP
            "G_HYBRID": "//mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&hl=az", // G_HYBRID
        };

        const defaultBasemap = ref(basemaps['G_HYBRID']);

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        const infoBody = (data, ll) => {
            let dh = '';
            // if( !G.is_mobile() ){
            //     for(let a in data.datas.IO){
            //         if( a != 'speed' && a != 'Ignition' && a != 'External Voltage' && a != 'Battery Voltage' )
            //             dh += `<tr><th>${a}</th><td>${data.datas.IO[a]}</td></tr>`
            //     }
            // }

            return `<div class="infoWindow">
                <table class="table table-hover">
                    <tbody>
                        <tr><th>${TR.value.car_type}</th><td>${data.car_type}</td></tr>
                        <tr><th>${TR.value.zone}</th><td>${data.zone_name}</td></tr>
                        <tr>
                            <th>${TR.value.coordinate}</th>
                            <td>
                                <a href="http://www.google.com/maps?t=k&q=loc:${ll[1]}+${ll[0]}" target="_blank" class="text-link text-underline">${ll[1]},${ll[0]}</a>
                            </td>
                        </tr>
                        <tr><th>Alt</th><td>${data.datas.altitude}</td></tr>
                        <tr><th>${TR.value.speed}</th><td>${data.datas.speed} km/h</td></tr>
                        <tr><th>${TR.value.date}</th><td>${data.gps_date}</td></tr>
                        <tr><th>Mühərrik</th><td><i class="fas fa-power-off text-light p-1 rounded-circle ${data.datas.IO.Ignition == 1 ? 'bg-success' : 'bg-danger'}"></i></td></tr>
                        <tr><th>Gərginlik</th><td>${(data.datas.IO['External Voltage']/1000).toFixed(2)} V</td></tr>
                        <tr><th>Batareya gərginliyi</th><td>${(data.datas.IO['Battery Voltage']/1000).toFixed(2)} V</td></tr>
                        <tr><th>${TR.value.note}</th><td>${data.car_note.replace(/\n/gi, "<br />")}</td></tr>
                        ${dh}
                    </tbody>
                </table>
                </div>`;
                        // <tr><th>${TR.value.battery_lifetime}</th><td>${data.battery_lifetime}</td></tr>
                        // <tr><th>${TR.value.lifetime_end}</th><td>${data.lifetime_end}</td></tr>
        };

        // const customerInfoBody = (data, ll) => {
        const customerInfoBody = (data) => {
            let dh = '';
            // let c = data.datas['coordinate'].split(',');

            for(let a in data.datas){
                if( a != 'speed' && a != 'coordinate'){
                    dh += `<tr><th>${TR.value[a] || a}</th><td>${data.datas[a]}</td></tr>`;
                }
                else if( a == 'coordinate' ){
                    let c = data.datas[a].split(',');
                    dh += `<tr><th>${TR.value[a] || a}</th><td>
                        <a href="http://www.google.com/maps?t=k&q=loc:${c[1]}+${c[0]}" target="_blank" class="text-link text-underline">${c[1]},${c[0]}</a>
                    </td></tr>`;
                }
            }
            return `<div class="infoWindow">
                <table class="table table-hover">
                    <tbody>
                        ${dh}
                    </tbody>
                </table>
                </div>`;
                        // <tr><th>${TR.value.car_type}</th><td>${data.car_type}</td></tr>
                        // <tr><th>${TR.value.zone}</th><td>${data.zone_name}</td></tr>
                        // <tr><th>Lat, Lon</th><td>${ll[1]}, ${ll[0]}</td></tr>
                        // <tr><th>Alt</th><td>${data.datas.altitude}</td></tr>
                        // <tr><th>${TR.value.speed}</th><td>${data.datas.speed} km/h</td></tr>
                        // <tr><th>${TR.value.date}</th><td>${data.gps_date}</td></tr>
                        // <tr><th>${TR.value.note}</th><td>${data.car_note.replace(/\n/gi, "<br />")}</td></tr>
                        // <tr><th>${TR.value.battery_lifetime}</th><td>${data.battery_lifetime}</td></tr>
                        // <tr><th>${TR.value.lifetime_end}</th><td>${data.lifetime_end}</td></tr>
        };

        // const infoBodyDetail = (features) => {
        //     let html = `<div style="width: auto; max-width: 800px; max-height: 600px; overflow: scroll;">
        //             <table class="table table-hover table-striped">
        //                 <thead>
        //                     <tr class="text-center">
        //                         <th scope="col">${TR.value.count}</th>
        //                         <th scope="col">${TR.value.gps_date}</th>
        //                         <th scope="col">Longitude</th>
        //                         <th scope="col">Latitude</th>
        //                     </tr>
        //                 </thead>
        //                 <tbody>`;
        //     features.forEach((f, i) => {
        //         let data = f.getProperties();
        //         html += `<tr>
        //                         <td>${i + 1}</td>
        //                         <td><img src="${data.image ? data.image : ''}" style="height: 80px;" /></td>
        //                         <td>${data.car_name}</td>
        //                         <td>${data.imei}</td>
        //                         <td>${data.gps_date}</td>
        //                         <td>${data.lon}</td>
        //                         <td>${data.lat}</td>
        //                     </tr>`;
        //     });
        //     return html + `</tbody>
        //             </table>
        //             </div>`;
        // };

        // const random_rgba = () => {
        //     var o = Math.round, r = Math.random, s = 255;
        //     return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + 1 + ')';
        //     // return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ')';
        // };

        const pointStyleFunction = (feature) => {
            let prop = feature.getProperties();
            let aid = prop.car_id;

            if (!styleCache[aid])
            {
                // carColor[aid] = random_rgba();
                carColor[aid] = `rgba(${prop.image_color},1)`; //random_rgba();

                styleCache[aid] = new Style({
                    // stroke: new Stroke({
                    //     color: "#0f44f6",
                    //     // color: carColor[aid],
                    //     width: 4,
                    // }),
                    fill: new Fill({
                        // color: "rgba(0, 255, 0, 1)",
                        color: carColor[aid],
                    }),
                    image: new CircleStyle({
                        radius: 8,
                        stroke: new Stroke({
                            // color: "rgba(255, 255, 255, 1)",
                            color: carColor[aid],
                            width: 4,
                        }),
                        fill: new Fill({
                            // color: "#00b0ff",
                            color: carColor[aid],
                        }),
                    }),
                    // geometry: function (feature) {
                    //     // return the coordinates of the first ring of the polygon
                    //     // const coordinates = feature
                    //     //     .getGeometry()
                    //     //     .getCoordinates()[0];
                    //     // return new Point(coordinates);
                    // },
                });
                styleCache[aid].prop = prop;
            }

            return styleCache[aid];
        };

        const pointStyleFunctionCur = (feature) => {
            let prop = feature.getProperties();
            let aid = prop.car_id;

            if (!styleCacheCur[aid])
            {
                // carColor[aid] = random_rgba();
                carColor[aid] = `rgba(${prop.image_color},1)`; //random_rgba();

                styleCacheCur[aid] = new Style({
                    stroke: new Stroke({
                        color: "#0f44f6",
                        // color: carColor[aid],
                        width: 4,
                    }),
                    fill: new Fill({
                        // color: "rgba(0, 255, 0, 1)",
                        color: carColor[aid],
                    }),
                    image: new CircleStyle({
                        radius: 8,
                        stroke: new Stroke({
                            // color: "rgba(255, 255, 255, 1)",
                            color: carColor[aid],
                            width: 4,
                        }),
                        fill: new Fill({
                            // color: "#00b0ff",
                            color: carColor[aid],
                        }),
                    }),
                    text: new Text({
                        text: `${prop.car_name.toString()}`,
                        fill: new Fill({
                            color: "rgba(255, 255, 255, 1)",
                        }),
                        // stroke: new Stroke({
                        //     color: "rgba(0, 0, 0, 0.7)",
                        //     width: 4,
                        // }),
                        backgroundFill: new Fill({
                            color: carColor[aid],
                        }),
                        offsetX: -12,
                        offsetY: -18,
                        font: 'bold 12px sans-serif',
                        padding: [3, 6, 3, 6],
                        textAlign: 'right',
                        textBaseline: 'middle',
                    }),
                    // geometry: function (feature) {
                    //     // return the coordinates of the first ring of the polygon
                    //     // const coordinates = feature
                    //     //     .getGeometry()
                    //     //     .getCoordinates()[0];
                    //     // return new Point(coordinates);
                    // },
                });
                styleCacheCur[aid].prop = prop;
            }

            return styleCacheCur[aid];
        };

        const customerStyleFunction = () => {
            return new Style({
                image: new Icon({
                    anchor: [0.5, 46],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'pixels',
                    src: '/assets/img/basket.png',
                    width: 40,
                }),
            });
        };

        // const getCoordinate = (lat, lon) => {
        //     var defaultMapProjectionCode = 'EPSG:3857';
        //     var dbFeatureProjectionCode = 'EPSG:4326';


        //     // var coordinate = transform([lon,lat], 'EPSG:4326', 'EPSG:3857');
        //     // var coordinate = transform([lon, lat], dbFeatureProjectionCode, defaultMapProjection);

        //     // console.log(`Transformed coords: ${coordinate}`);
        //     return coordinate;
        // };

        const getAngleOfRotation = (sourceLat, sourceLon, destinationLat, destinationLon) => {
            // (x,y) = Lon, lat
            // coordinate = [Lon, Lat]
            // transform coordinates to EPSG:3857
            const sourceCoord = [sourceLat, sourceLon];

            const destCoord = [destinationLat, destinationLon];

            const dx = destCoord[0] - sourceCoord[0];
            const dy = destCoord[1] - sourceCoord[1];

            const bearingRad = Math.atan2(dx, dy);
            // const bearingDeg = (bearingRad * 180 / Math.PI + 360) % 360;
            // console.log(`bearingPlanar: ${bearingDeg} degrees`);
            return bearingRad;
        };

        const lineStyleFunction = (feature) => {
            // console.log(feature, feature.getGeometry().getCoordinates());
            let geometry = feature.getGeometry();
            let prop = feature.getProperties();
            // let aid = prop.car_id;

            if(geometry.getType() == 'LineString'){
                // console.log(prop);
                const styles = [
                    new Style({
                        stroke: new Stroke({
                            // color: "#0f44f6e8",
                            // color: "#1967d2",
                            // color: "#00b0ff",
                            color: `rgba(${prop.image_color},1)`,
                            width: 5,
                        }),
                        text: prop.lineLength ? new Text({
                            text: `${prop.lineLength}`,
                            fill: new Fill({
                                color: "rgba(255, 255, 255, 1)",
                            }),
                            // stroke: new Stroke({
                            //     color: "rgba(0, 0, 0, 0.7)",
                            //     width: 4,
                            // }),
                            backgroundFill: new Fill({
                                color: `rgba(${prop.image_color},1)`, //carColor[aid],
                            }),
                            // offsetX: -12,
                            // offsetY: -18,
                            font: 'bold 12px sans-serif',
                            padding: [3, 6, 3, 6],
                            textAlign: 'right',
                            textBaseline: 'middle',
                        }) : null,
                    })
                    // new Style({
                    //     stroke: new Stroke({
                    //         // color: "#0f44f6e8",
                    //         color: "#00b0ff",
                    //         width: 4,
                    //     }),
                    // }),
                ];

                if (olMap.value.getView().getZoom() > 15 && geometry.getCoordinates().length > 1)
                {
                    geometry.forEachSegment(function (start, end) {
                        let rotation = getAngleOfRotation(start[1], start[0], end[1], end[0]);
                        // let p = vectorLayerLine.value.getSource().getFeaturesAtCoordinate(start);
                        // if( p ){
                        //     prop = p[0].getProperties();
                        // }
                        // arrows
                        styles.push( new Style({
                                geometry: new Point(start),
                                image: new Icon({
                                    src: '/assets/images/arrow.png',
                                    // src: '/assets/images/' + (prop.datas && prop.datas.speed > 0 ? 'blue_arrow.png' : 'red_arrow.png'),
                                    // anchor: [1.65, 0.47],
                                    anchor: [-0.3, 0.5],
                                    anchorXUnits: 'fraction',
                                    anchorYUnits: 'fraction',
                                    rotateWithView: true,
                                    rotation: -rotation,
                                    scale: 0.9,
                                })
                            })
                        );
                    });
                }

                return styles;
            }
            else if( geometry.getType() == 'Point'){
                return new Style({
                    image: new CircleStyle({
                        radius: 6,
                        stroke: new Stroke({
                            color: "rgba(255, 255, 255, 1)",
                            width: 2,
                        }),
                        fill: new Fill({
                            color: prop.datas && prop.datas.speed > 0 ? "rgba(0, 0, 255, 1)" : "rgba(255, 0, 0, 1)",
                        }),
                    }),
                    text: dt_toolbar_buttons.label ? new Text({
                        text: `${prop.car_name.toString()}`,
                        fill: new Fill({
                            color: "rgba(255, 255, 255, 1)",
                        }),
                        // stroke: new Stroke({
                        //     color: "rgba(0, 0, 0, 0.7)",
                        //     width: 4,
                        // }),
                        backgroundFill: new Fill({
                            color: `rgba(${prop.image_color},1)`, //carColor[aid],
                        }),
                        offsetX: -12,
                        offsetY: -18,
                        font: 'bold 12px sans-serif',
                        padding: [3, 6, 3, 6],
                        textAlign: 'right',
                        textBaseline: 'middle',
                    }) : null,
                });
            }
        };

        // const updateSource = () => {
        //     const view = olMap.value.getView();
        //     const source = vectorLayer.value.getSource();
        //     // const features = new GeoJSON({
        //     //     featureProjection: "EPSG:3857",
        //     // }).readFeatures(data);
        //     // source.clear();
        //     // source.addFeatures(features);
        //     // source.addFeatures(polygon);
        //     // view.fit(source.getExtent());
        // };

        /*const clusterSource = new Cluster({
            distance: parseInt(40, 10),
            minDistance: parseInt(20, 10),
            source: new VectorSource(),
        });

        const clusters = new VectorLayer({
            source: clusterSource,
            style: function (feature) {
                const size = feature.get('features').length;
                let style = styleCache[size];
                if (!style) {
                    style = new Style({
                        fill: new Fill({
                            color: "rgba(0, 255, 0, 1)",
                        }),
                        image: new CircleStyle({
                            radius: 12,
                            // stroke: new Stroke({
                            //     color: '#000',
                            // }),
                            fill: new Fill({
                                color: "rgba(0, 255, 0, 1)",
                            }),
                        }),
                        text: new Text({
                            text: size.toString(),
                            fill: new Fill({
                                color: '#000',
                            }),
                        }),
                    });
                    styleCache[size] = style;
                }
                return style;
            },
        });*/

        // const mousePositionControl = new MousePosition({
        //     coordinateFormat: createStringXY(7),
        //     projection: 'EPSG:3857',
        //     // comment the following two lines to have the mouse position
        //     // be placed within the map.
        //     // className: 'one-mouse-position',
        //     // target: document.getElementById('mouse-position'),
        //     undefinedHTML: '',
        // });

        const baseMapLayerSource = ref(new XYZ({
            crossOrigin: "anonymous",
            //wrapX: false,
            url: defaultBasemap.value, // "//mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&hl=az", // G_HYBRID
        }));

        const baseMapLayer = new TileLayer({
            //visible: false,
            //preload: Infinity,
            source: baseMapLayerSource.value,
            useInterimTilesOnError: true,
            name: "basemap",
            crossOrigin: "anonymous",
            zIndex: 0,
        });

        const duration = 2000;
        const flash = (feature) => {
            const flashGeom = feature.getGeometry().clone();
            firstLastFeatureId.value = feature.getProperties().car_id;
            listenerKey[firstLastFeatureId.value] = vectorCurPosLayer.value.on('postrender', animate);
            var elapsed = 0;

            function animate(event) {
                // const start = Date.now();
                // const frameState = event.frameState;
                // const elapsed = frameState.time - start;
                elapsed += 40;
                if (elapsed >= duration) {
                    elapsed = 0;
                    // unByKey(listenerKey[feature.getProperties().car_id]);
                    // return;
                }
                const vectorContext = getVectorContext(event);
                const elapsedRatio = elapsed / duration;
                // radius will be 5 at start and 30 at end.
                const radius = easeOut(elapsedRatio) * 25 + 8;
                const opacity = easeOut(1 - elapsedRatio);

                const style = new Style({
                    image: new CircleStyle({
                        radius: radius,
                        stroke: new Stroke({
                            // color: `rgba(255, 0, 0, ${opacity})`,
                            color: `rgba(${feature.getProperties().image_color},${opacity})`,
                            width: 3.5 + opacity,
                        }),
                    }),
                    zIndex: 999,
                    // image: new Icon({
                    //     // anchor: [0.5, 46],
                    //     // anchorXUnits: 'fraction',
                    //     // anchorYUnits: 'pixels',
                    //     src: 'http://localhost:8080/assets/img/radar.svg',
                    //     opacity: 1,
                    //     // src: 'data:image/svg+xml;utf8,' + svg,
                    //     scale: 0.3
                    // }),
                });

                vectorContext.setStyle(style);
                vectorContext.drawGeometry(flashGeom);
                olMap.value.render();
            }
            olMap.value.render();
        };

        const showPopup = async (featureData, coordinate) => {
            let element = popup.value.getElement();
            popover.value = window.bootstrap.Popover.getInstance(element);

            if (popover.value) {
                popover.value.dispose();
                popover.value = undefined;
            }

            // if(featureData.ftype !== undefined && featureData.ftype == 'customer'){
            //     await ajax({
            //         // url: "https://maps.googleapis.com/maps/api/geocode/json?" + 'key=' + oda.mapkey + `&sensor=false&language=az&latlng=${c[1]},${c[0]}`,
            //         url: `https://nominatim.openstreetmap.org/search?format=json&accept-language=az&q=${coordinate[1]},${coordinate[0]}`,
            //         // csrf: false,
            //         success: (e) => {
            //             featureData.datas['Map Address'] = e.data[0].display_name;
            //         }
            //     });
            // }

            popover.value = new window.bootstrap.Popover(element, {
                animation: false,
                // container: document.body,
                // container: olMap.value.getOverlayById('overlay').getElement(),
                container: element,
                content: featureData.ftype === undefined || featureData.ftype != 'customer' ? infoBody(featureData, coordinate) : customerInfoBody(featureData, coordinate), //feature.length == 1 ? infoBody(featureData, coordinate) : infoBodyDetail(feature),
                // offset: [0, 20],
                placement: "top",
                sanitize: false,
                html: true,
                title: (featureData.ftype === undefined || featureData.ftype != 'customer') ? `<table>
                            <tbody>
                                <tr>
                                    <td rowspan="4" class="align-middle ps-2"><div class="bg-cover popover-head-img" style="background-size: cover; background-image: url(${featureData.image});"></div></td>
                                    <td class="align-middle ps-3"><strong>${featureData.car_name}</strong></td>
                                </tr>
                                <tr>
                                    <td class="align-middle ps-3"><small>${TR.value.device} ${TR.value.name}: &nbsp;${featureData.device_name}</small></td>
                                </tr>
                                <tr>
                                    <td class="align-middle ps-3"><small>IMEI: &nbsp;${featureData.imei}</small></td>
                                </tr>
                            </tbody>
                        </table>` :
                        // `<table>
                        //     <tbody>
                        //         <tr>
                        //             <td rowspan="4" class="align-middle ps-2"><div class="bg-cover popover-head-img" style="background-size: cover; background-image: url(${featureData.image});"></div></td>
                        //             <td class="align-middle ps-3">${featureData.car_name}</td>
                        //         </tr>
                        //         <tr>
                        //             <td class="align-middle ps-3"><small>${TR.value.device} ${TR.value.name}: &nbsp;${featureData.device_name}</small></td>
                        //         </tr>
                        //         <tr>
                        //             <td class="align-middle ps-3"><small>IMEI: &nbsp;${featureData.imei}</small></td>
                        //         </tr>
                        //     </tbody>
                        // </table>` :
                        `<table>
                            <tbody>
                                <tr>
                                    <td rowspan="4" class="align-middle ps-2"><div class="bg-cover popover-head-img" style="background-size: cover; background-image: url(${featureData.image});"></div></td>
                                    <td class="align-middle ps-3">${featureData.name}</td>
                                </tr>
                            </tbody>
                        </table>`,

                // <tr><th>${TR.value.device} ${TR.value.name}</th><td>${data.device_name}</td></tr>
                // <tr><th>IMEI</th><td>${data.imei}</td></tr>


                // title: `<div class="row d-flex-inline align-items-center">
                //             <div class="col text-start ps-4">
                //                 <div class="bg-cover float-start mx-3 popover-head-img" style="background-image: url(${featureData.image});"></div>
                //                 <div class="float-start">${featureData.car_name}</div>
                //             </div>
                //         </div>`,

                // title: feature.length == 1 ? `<small>
                //             ${TR.value.device} ${TR.value.name}: ${featureData.device_name}<br />
                //             IMEI: ${featureData.imei}<br />
                //             ${TR.value.phone}: ${featureData.phone}
                //             </small>` : TR.value.detail_info_title.toString(),
            });
            popover.value.show();
        };

        const initMap = () => {
            // a new vector layer is created with the feature
            vectorLayer.value = new VectorLayer({
                // source: new VectorSource({
                //     features: new GeoJSON().readFeatures(geojsonObject),
                // }),
                source: new VectorSource({
                    // loader: (extent, resolution, projection, success, failure) => {
                    //     getCurrentPositions();
                    // }
                }),
                style: pointStyleFunction,
                // wrapX: false,
            });
            vectorCurPosLayer.value = new VectorLayer({
                // source: new VectorSource({
                //     features: new GeoJSON().readFeatures(geojsonObject),
                // }),
                source: new VectorSource({
                    // loader: (extent, resolution, projection, success, failure) => {
                    //     getCurrentPositions();
                    // }
                }),
                style: pointStyleFunctionCur,
                // wrapX: false,
            });
            customerLayer.value = new VectorLayer({
                // source: new VectorSource({
                //     features: new GeoJSON().readFeatures(geojsonObject),
                // }),
                source: new VectorSource({
                    // loader: (extent, resolution, projection, success, failure) => {
                    //     getCurrentPositions();
                    // }
                }),
                style: customerStyleFunction,
                visible: false,
                // wrapX: false,
            });

            vectorLayerLine.value = new VectorLayer({
                // source: new VectorSource({
                //     features: new GeoJSON().readFeatures(geojsonObject),
                // }),

                source: new VectorSource(),
                style: lineStyleFunction
                // style: new Style({
                //     stroke: new Stroke({
                //         color: "red",
                //         width: 5,
                //     }),
                // }),
            });

            olMap.value = new Map({
                // the map will be created using the 'map-root' ref
                target: "map",
                // controls: defaultControls().extend([mousePositionControl]),
                controls: defaultControls().extend([
                    new ScaleLine({
                        units: "metric",
                        target: "map_scale",
                        // bar: true,
                        // steps: parseInt(4, 10),
                        // text: true,
                        // minWidth: 140,
                    })
                ]),
                // overlays: [popup.value],
                layers: [
                    // adding a background tiled layer
                    // new TileLayer({
                    //     source: new OSM(), // tiles are served by OpenStreetMap
                    // }),

                    baseMapLayer,

                    // new VectorLayer({
                    //     source: new VectorSource({
                    //         // features: [new Feature(point).setProperties({"ol_uid": "1", "id": "34234"})],
                    //         features: [new Feature(point)],
                    //         // features: [new Feature(object1), new Feature(polygon)],
                    //         // features: [object1, polygon],
                    //     }),
                    //     style: {
                    //         "circle-radius": 9,
                    //         "circle-fill-color": "red",
                    //     },
                    // }),

                    // the vector layer is added above the tiled OSM layer
                    vectorLayerLine.value,
                    vectorLayer.value,
                    vectorCurPosLayer.value,
                    customerLayer.value,
                    // clusters,
                ],

                // the map view will initially show the whole world
                view: new View({
                    // projection: "EPSG:3857",
                    // center: olProj.transform([44.8608285586, 40.3900191032], "EPSG:4326", "EPSG:3857"),

                    // center: [48.4608285586, 40.3900191032],
                    center: [48.0588266, 40.2008005],
                    zoom: 8,
                    maxZoom: 22,
                    // constrainResolution: true,
                    // multiWorld: true,
                }),
            });
            // console.log(olProj.transform([49.8608285586, 40.3900191032], "EPSG:4326", "EPSG:3857"));

            olMap.value.on("pointermove", (event) => {
                // will return the first feature under the pointer
                // const hovered = olMap.value.forEachFeatureAtPixel(
                //     event.pixel,
                //     (feature) => feature
                // );

                const type = olMap.value.hasFeatureAtPixel(event.pixel)
                    ? "pointer"
                    : "inherit";
                olMap.value.getViewport().style.cursor = type;

                document.getElementById('mouse_position').innerHTML = event.coordinate.map((a) => a.toFixed(7) ).join(', ');

            });

            // const popup = new Overlay({
            //     element: document.getElementById('popup'),
            // });
            // olMap.value.addOverlay(popup);

            // const select = new Select({
            //     condition: click,
            // });

            // olMap.value.addInteraction(select);

            // select.on('select', e => {
            //     const features = e.selected;
            //     if (features !== undefined && features.length === 1) {
            //         const coords = features[0].getGeometry().getCoordinates();
            //         popup.value.setPosition(coords);

            //         popover.value = new bootstrap.Popover(document.getElementById(popup.value.getElement().id), {
            //         container: popup.value.getElement(),
            //         html: true,
            //         content: coords.toString(), //infoBody(features.getProperties(), coords)
            //         });

            //         popover.value.show();
            //     }
            // });

            // select.getFeatures().on('remove', e => {
            //     if (popover.value) {
            //         popover.value.dispose();
            //         popover.value = null;
            //     }
            // });


            olMap.value.on("click", function (event) {
                const element = popup.value.getElement();
                popover.value = window.bootstrap.Popover.getInstance(element);
                if (popover.value) {
                    popover.value.dispose();
                    popover.value = undefined;
                }

                let fs = olMap.value.getFeaturesAtPixel(event.pixel);
                if (!fs) {
                    // if(document.querySelectorAll('#popup-closer')){
                    //     document.querySelectorAll('#popup-closer').removeEventListener('click', closer.value);
                    // }
                    return;
                }

                let featureData, coordinate;
                let feature = [];

                fs.forEach((f) => {
                    if (f.getGeometry().getType() == 'Point') feature.push(f);
                });
                fs = null;

                if (feature.length > 0) {
                    let f = feature[0];
                    const coordinate1 = f.getGeometry().getCoordinates();
                    coordinate = coordinate1;
                    if (coordinate1[0].length == 2) {
                        coordinate = coordinate1[0];
                    } else if (coordinate1[0].length == 4) {
                        coordinate = coordinate1[0][0];
                    }
                    popup.value.setPosition([
                        coordinate[0] + Math.round(event.coordinate[0] / 360) * 360,
                        coordinate[1],
                    ]);
                    featureData = f.getProperties();

                    if(feature.length == 1){
                        showPopup(featureData, coordinate);
                        // if( (featureData.ftype === undefined || featureData.ftype != 'customer') && (featureData.layername === undefined || featureData.layername != 'curpos') && (featureData.layername === undefined || featureData.layername != 'carline')  ){
                        //     setFeatureSelected(f);
                        // }
                    }
                    else{
                        showDetailInfo.value = true;
                        showDetailInfoBody.value = true;
                        pointDetails.value['device'] = {};
                        pointDetails.value['points'] = [];

                        feature.forEach((a) => {
                            let prop = a.getProperties();
                            let coord = a.getGeometry().getCoordinates();

                            if( prop.ftype === undefined || prop.ftype != 'customer'  ){
                                pointDetails.value['device'][prop.imei] = {
                                    "car_name": prop.car_name,
                                    "car_type": prop.car_type,
                                    "device_name": prop.device_name,
                                    "imei": prop.imei,
                                    // "phone": prop.phone,
                                    "battery_lifetime": prop.battery_lifetime,
                                    "lifetime_end": prop.lifetime_end,
                                };
                                pointDetails.value['points'].push({
                                    "car_name": prop.car_name,
                                    "car_type": prop.car_type,
                                    "zone_name": prop.zone_name,
                                    "lon": coord[0],
                                    "lat": coord[1],
                                    "gps_date": prop.gps_date,
                                    "speed": prop.datas && prop.datas.speed ? prop.datas.speed : '',
                                });
                            }
                            else{
                                pointDetails.value['device'] = null;
                                pointDetails.value['points'].push({
                                    "name": prop.name,
                                    "phone": prop.phone,
                                    "email": prop.email,
                                    "lon": coord[0],
                                    "lat": coord[1]
                                    // "gps_date": prop.gps_date,
                                    // "speed": prop.datas && prop.datas.speed ? prop.datas.speed : '',
                                });
                            }
                        });
                    }

                }
                else{
                    // clearSelectedFeature();
                }
            });
        };

        onUnmounted(() => {
            if (popover.value) {
                popover.value.dispose();
                popover.value = undefined;
            }
            olMap.value.dispose();
            clearInterval(curposinterval.value);
        });

        onMounted(async () => {
            useGeographic();

            initMap();

            // Popup showing the position the user clicked
            popup.value = new Overlay({
                // id: 'overlay',
                element: document.getElementById("popup"),
                // autoPan: {
                //     animation: {
                //         duration: 250,
                //     },
                // },
                autoPan: true,
                autoPanAnimation: {
                    duration: 100
                }
            });
            olMap.value.addOverlay(popup.value);

            // getCurrentPositions();

            // curposinterval.value = setInterval(() => {
            //     getCurrentPositions();
            // }, 30000);

            // getAllCustomers();
            // getAllCars();

            infoTitle.value = TR.value.detail_info_title;
        });

        const getAllDevicePositions = () => {
            comboFilter.value = constComboLabel;
            selectedDevice.value = 0;
            DT_clearMap();
            olMap.value.getView().fit(vectorCurPosLayer.value.getSource().getExtent());
            olMap.value.getView().setZoom(olMap.value.getView().getZoom() - 1);

            getCurrentPositions();
        };

        const getCurrentPositions = async () => {
            vectorCurPosLayer.value.getSource().clear();

            // await ajax({
            //     url: store.getPositions(),
            //     // url: store.getPositionsByDate(0, ','),
            //     success: (e) => {
            //         const res = e.data || null;
            //         if (res) {
            //             if( res[0].geom.features != null ){
            //                 if(dt_toolbar_buttons.flash){
            //                     DT_removeFlashListener();
            //                     dt_toolbar_buttons.flash = true;
            //                 }

            //                 let pos = new GeoJSON().readFeatures(res[0].geom);
            //                 vectorCurPosLayer.value.getSource().addFeatures(pos);
            //                 // olMap.value.getView().fit(vectorLayer.value.getSource().getExtent());
            //                 // olMap.value.getView().setZoom(olMap.value.getView().getZoom() - 1);

            //                 if(dt_toolbar_buttons.flash){
            //                     DT_flashLastPoint();
            //                 }
            //             }
            //         }
            //     }
            // });
            // comboFilter.value = constComboLabel;
        };

        const getPositionsByDeviceID = async (device) => {
            let device_id = device.device_id;
            selectedDevice.value = device;
            vectorLayerLine.value.getSource().clear();
            // pointDetails.value['device'] = {};
            // pointDetails.value['points'] = [];

            if( device_id != 0 ){
                comboFilter.value = cars.value.filter((a) => a.device_id == device_id)[0].car_name;
            }
            else{
                comboFilter.value = constComboLabel;
            }

            // await ajax({
            //     // url: store.getPositionsByDevice(device_id),
            //     url: store.getPositionsByDate(device_id, ','),
            //     success: (e) => {
            //         const res = e.data || null;
            //         if (res) {
            //             let points = new GeoJSON().readFeatures(res[0].geom);
            //             // let lines = new LineString(res[1].geom.coordinates);
            //             vectorLayerLine.value.getSource().addFeatures(points);

            //             // var lineString = new LineString(res[1].geom.coordinates).transform('EPSG:4326', 'EPSG:3857')
            //             // // lineLength.value = formatLength(lineString, {projection: 'EPSG:4326'});
            //             // lineLength.value = formatLength(lineString);

            //             for (var j = 1; j < res.length; j++) {
            //                 let lines = new GeoJSON().readFeatures(res[j].geom);
            //                 // console.log(lines[0].getProperties());
            //                 for(let i=0; i < lines.length; i++){
            //                     let ls = lines[i].getProperties();
            //                     // let ps = points[i].getProperties();
            //                     // lines[i].setProperties(Object.assign(ps, ls));

            //                     // let ps = groupBy(points, 'device_id');
            //                     // let o = ps[res[i].geom.device_id];
            //                     // // console.log(lines);
            //                     // lines[i].setProperties(Object.assign(o, ls));
            //                     let ps = groupBy(points, 'device_id');
            //                     let o = ps[res[j].device_id];
            //                     lines[i].setProperties(Object.assign({'image_color': o.image_color, 'datas': o.datas}, ls));
            //                 }
            //                 vectorLayerLine.value.getSource().addFeatures(lines);
            //             }
            //             olMap.value.getView().fit(vectorLayerLine.value.getSource().getExtent());
            //             olMap.value.getView().setZoom(olMap.value.getView().getZoom() - 1);
            //         }
            //     }
            // });

        };

        // const groupBy = (ds, key) => {
        //     return ds.reduce((rv, e) => {
        //         let x = e.getProperties();
        //         rv[x[key]] = x;
        //         return rv;
        //     }, {});
        // };

        const lineLength = ref(0);

        const getPositionByDateInterval = async () => {
            vectorLayerLine.value.getSource().clear();

            // let dt = (datepicker_start.value ? moment(datepicker_start.value).valueOf() : '') + ',' + (datepicker_end.value ? moment(datepicker_end.value).valueOf() : '');

            // await ajax({
            //     url: store.getPositionsByDate(selectedDevice.value?.device_id || 0, dt ),
            //     // url: store.getPositionsByDate(selectedDevice.value?.device_id || 0, datepicker.value.length ? datepicker.value.map((a) => a != null ? moment(a).valueOf() : '' ).join(',') : '' ),
            //     success: (e) => {
            //         const res = e.data || null;
            //         if (res.length) {

            //             let points = new GeoJSON().readFeatures(res.filter(r => r.geom.type == 'FeatureCollection')[0].geom);
            //             vectorLayerLine.value.getSource().addFeatures(points);
            //             let ps = groupBy(points, 'device_id');

            //             // let lpoints = [];
            //             // for (var i = 0; i < res[0].geom.features.length; i++) {
            //             //     // lpoints[i] = res[0].geom.features[i].geometry.coordinates; //transform(res[0].geom.features[i].geometry.coordinates, 'EPSG:4326', 'EPSG:3857');
            //             //     let l = new LineString([res[0].geom.features[i].geometry.coordinates, res[0].geom.features[i+1].geometry.coordinates]);

            //             //     let ls = l.getProperties();
            //             //     let ps = points[i].getProperties();
            //             //     // l.setProperties(Object.assign({'image_color': ps.image_color, 'datas': ps.datas}, ls));
            //             //     lpoints[i] = new Feature(l
            //             //          //.transform('EPSG:4326', 'EPSG:3857')
            //             //     );
            //             //     vectorLayerLine.value.getSource().addFeature(lpoints[i]);
            //             // }
            //             // console.log(lpoints);
            //             // var featureLine = new Feature({
            //             //     geometry: new LineString(lpoints) //.transform('EPSG:4326', 'EPSG:3857')
            //             // });
            //             // vectorLayerLine.value.getSource().addFeatures(lpoints);

            //             // var lineString = new LineString(res[1].geom.coordinates).transform('EPSG:4326', 'EPSG:3857')
            //             // // // // lineLength.value = formatLength(lineString, {projection: 'EPSG:4326'});
            //             // lineLength.value = formatLength(lineString);

            //             lineLength.value = 0;
            //             res.filter(r => r.geom.type == 'LineString').forEach(r => {
            //                 let lines = new GeoJSON().readFeature(r.geom);
            //                 lineLength.value += r.linelength;
            //                 // lineLength.value += lines.getGeometry().getLength();

            //                 let ls = lines.getProperties();
            //                 let o = ps[r.device_id];
            //                 lines.setProperties(Object.assign({
            //                     'image_color': o.image_color,
            //                     'lineLength': (r.linelength && r.linelength != 0) ? ( r.linelength < 1 ? ((r.linelength * 1000).toFixed(0) + ' m') : (r.linelength.toFixed(3) + ' km') ) : '',
            //                     'datas': o.datas
            //                 }, ls));

            //                 vectorLayerLine.value.getSource().addFeature(lines);
            //             });
            //             // lineLength.value = formatLength(lineLength.value);
            //             lineLength.value = lineLength.value < 1 ? ((lineLength.value * 1000).toFixed(0) + ' m') : (lineLength.value.toFixed(3) + ' km');

            //             olMap.value.getView().fit(vectorLayerLine.value.getSource().getExtent());
            //             olMap.value.getView().setZoom(olMap.value.getView().getZoom() - 1);
            //         }
            //         else{
            //             G.toast.warn({msg: "Məlumat yoxdur !"});
            //         }
            //     },
            //     error: () => {
            //         G.toast.warn({msg: "Məlumat yoxdur !"});
            //     }
            // });
        };

        // const formatLength = function (length) {
        //     // const length = getLength(line);
        //     let output;
        //     if (length > 1000) {
        //         output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
        //     } else {
        //         output = Math.round(length * 100) / 100 + ' ' + 'm';
        //     }
        //     return output;
        // };

        // const getStopedPosition = () => {
        //     // let a = {};
        //     // let feas = {};
        //     let points = vectorLayerLine.value.getSource().getFeatures();
        //     points.forEach(f => {
        //         let prop = f.getProperties();
        //         if( prop.datas && prop.datas.speed == 0 ){
        //             f.setProperties({"stopedPos": true});
        //             f.setStyle(
        //                 new Style({
        //                     stroke: new Stroke({
        //                         // color: "#0f44f6",
        //                         color: `rgba(${prop.image_color},1)`,
        //                         width: 4,
        //                     }),
        //                     fill: new Fill({
        //                         // color: "rgba(0, 255, 0, 1)",
        //                         color: `rgba(${prop.image_color},1)`,
        //                     }),
        //                     image: new CircleStyle({
        //                         radius: 10,
        //                         stroke: new Stroke({
        //                             color: "rgba(255, 255, 255, 1)",
        //                             // color: `rgba(${prop.image_color},1)`,
        //                             width: 2,
        //                         }),
        //                         fill: new Fill({
        //                             // color: "#00ff00",
        //                             color: `rgba(${prop.image_color},1)`,
        //                         }),
        //                     }),
        //                 })
        //             );
        //         }
        //     });
        // };

        const getAllCustomers = async () => {
            customerLayer.value.getSource().clear();
            // await ajax({
            //     // url: store.getPositionsByDevice(2),
            //     url: store.getCustomersForMap(),
            //     success: (e) => {
            //         const res = e.data || null;
            //         if (res) {
            //             let pos = new GeoJSON().readFeatures(res[0].geom);
            //             customerLayer.value.getSource().addFeatures(pos);

            //             // olMap.value.getView().fit(customerLayer.value.getSource().getExtent());
            //             // olMap.value.getView().setZoom(olMap.value.getView().getZoom() - 1);
            //         }
            //     }
            // });
        };

        const viewPoint = (item) => {
            let f = vectorLayerLine.value.getSource().getFeatures().find(e => e.getGeometry().getCoordinates()[0] == item.lon && e.getGeometry().getCoordinates()[1] == item.lat && e.getProperties().gps_date == item.gps_date);

            if ( f === undefined ){
                f = vectorCurPosLayer.value.getSource().getFeatures().find(e => e.getGeometry().getCoordinates()[0] == item.lon && e.getGeometry().getCoordinates()[1] == item.lat && e.getProperties().gps_date == item.gps_date);
            }

            if ( f === undefined ){
                f = customerLayer.value.getSource().getFeatures().find(e => e.getGeometry().getCoordinates()[0] == item.lon && e.getGeometry().getCoordinates()[1] == item.lat && e.getProperties().gps_date == item.gps_date);
            }

            if (f){
                // setFeatureSelected(f);

                popup.value.setPosition([
                    item.lon,
                    item.lat
                ]);

                showPopup(f.getProperties(), [item.lon, item.lat]);
            }

            olMap.value.getView().setCenter([item.lon, item.lat]);
            olMap.value.getView().setZoom(19);
        };

        // const setFeatureSelected = async (f) => {
        //     // await clearSelectedFeature();
        //     lastSelectedFeature.value = f;

        //     // flashfeature.value = f.getGeometry().clone();
        //     // baseMapLayer.on('postrender', animate);

        //     f.setStyle(
        //         new Style({
        //             image: new CircleStyle({
        //                 radius: 8,
        //                 stroke: new Stroke({
        //                     color: "rgba(255, 0, 0, 1)",
        //                     width: 4,
        //                 }),
        //                 fill: new Fill({
        //                     color: "#ffffff",
        //                 }),
        //             }),
        //             text: dt_toolbar_buttons.label ? new Text({
        //                 text: `${f.getProperties().car_name.toString()}`,
        //                 fill: new Fill({
        //                     color: "rgba(255, 255, 255, 1)",
        //                 }),
        //                 // stroke: new Stroke({
        //                 //     color: "rgba(0, 0, 0, 0.7)",
        //                 //     width: 4,
        //                 // }),
        //                 backgroundFill: new Fill({
        //                     // color: "#ff0054b0",
        //                     // color: "#ffffff",
        //                     color: `rgba(${f.getProperties().image_color},1)`,
        //                 }),
        //                 offsetX: -12,
        //                 offsetY: -18,
        //                 font: 'bold 12px sans-serif',
        //                 padding: [3, 6, 3, 6],
        //                 // radius: [3, 6, 3, 6],
        //                 textAlign: 'right',
        //                 textBaseline: 'middle',
        //             }) : null,
        //         })
        //     );
        // };

        // const clearSelectedFeature = async () => {
        //     if( lastSelectedFeature.value != null ){
        //         let prop = lastSelectedFeature.value.getProperties();
        //         let aid = prop.car_id;

        //         lastSelectedFeature.value.setStyle(
        //             new Style({
        //                 image:
        //                 prop.datas && prop.datas.speed > 0 ?
        //                 new CircleStyle({
        //                     radius: 8,
        //                     stroke: new Stroke({
        //                         // color: "rgba(255, 255, 255, 1)",
        //                         color: carColor[aid],
        //                         width: 2,
        //                     }),
        //                     fill: new Fill({
        //                         // color: "#00b0ff",
        //                         color: carColor[aid],
        //                     }),
        //                 })
        //                 : new CircleStyle({
        //                     radius: 10,
        //                     stroke: new Stroke({
        //                         color: "rgba(255, 255, 255, 1)",
        //                         // color: carColor[aid],
        //                         width: 2,
        //                     }),
        //                     fill: new Fill({
        //                         // color: "#00ff00",
        //                         color: `rgba(${prop.image_color},1)`,
        //                     }),
        //                 }),
        //                 text: dt_toolbar_buttons.label ? new Text({
        //                     text: `${lastSelectedFeature.value.getProperties().car_name.toString()}`,
        //                     fill: new Fill({
        //                         color: "rgba(255, 255, 255, 1)",
        //                         // color: carColor[aid],
        //                     }),
        //                     backgroundFill: new Fill({
        //                         color: carColor[aid],
        //                     }),
        //                     offsetX: -12,
        //                     offsetY: -18,
        //                     font: 'bold 12px sans-serif',
        //                     padding: [3, 6, 3, 6],
        //                     textAlign: 'right',
        //                     textBaseline: 'middle',
        //                 }) : null,
        //             })
        //         );
        //         lastSelectedFeature.value = null;
        //     }
        // };

        // const getAllCars = async () => {
        //     await ajax({
        //         url: store.getCar(),
        //         success: (e) => {
        //             const res = e.data || null;
        //             if (res) {
        //                 cars.value = res.map((a) => {
        //                     return { "id": a.id, "device_id": a.device.id, "car_name": a.name };
        //                 });
        //             }
        //         }
        //     });
        // };

        const changeBasemap = (index) => {
            // baseMapLayerSource.setUrl('');
            baseMapLayerSource.value = new XYZ({
                // crossOrigin: "anonymous",
                url: ''
            });
            if( basemaps[index] != '' ){
                baseMapLayerSource.value.setUrl(basemaps[index]);
            }
            baseMapLayer.setSource(baseMapLayerSource.value);
        };

        const DT_showLabels = async () => {
            dt_toolbar_buttons.label = !dt_toolbar_buttons.label;
            vectorLayerLine.value.setStyle(lineStyleFunction);

            // Object.entries(styleCache).forEach(([aid,val]) => {
            //     if( dt_toolbar_buttons.label ){
            //         styleCache[aid].setText(new Text({
            //             text: `${styleCache[aid].prop.car_name.toString()}`,
            //             fill: new Fill({
            //                 color: "rgba(255, 255, 255, 1)",
            //             }),
            //             // stroke: new Stroke({
            //             //     color: "rgba(0, 0, 0, 0.7)",
            //             //     width: 4,
            //             // }),
            //             backgroundFill: new Fill({
            //                 color: carColor[aid],
            //             }),
            //             offsetX: -12,
            //             offsetY: -18,
            //             font: 'bold 12px sans-serif',
            //             padding: [3, 6, 3, 6],
            //             textAlign: 'right',
            //             textBaseline: 'middle',
            //         }));
            //     }
            //     else{
            //         styleCache[aid].setText(null);
            //     }
            // });
            // await vectorLayerLine.value.getSource().getFeatures().forEach(f => {
            //     let prop = f.getProperties();
            //     let aid = prop.car_id;
            //     // if( prop.datas && prop.datas.speed == 0 )
            //     {
            //         // if( f.getGeometry().getType() == 'Point'){
            //         // let fst = f.getStyle();
            //         // if( dt_toolbar_buttons.label ){
            //         //     fst.setText(new Text({
            //         //         text: `${prop.car_name.toString()}`,
            //         //         fill: new Fill({
            //         //             color: "rgba(255, 255, 255, 1)",
            //         //         }),
            //         //         // stroke: new Stroke({
            //         //         //     color: "rgba(0, 0, 0, 0.7)",
            //         //         //     width: 4,
            //         //         // }),
            //         //         backgroundFill: new Fill({
            //         //             color: carColor[aid],
            //         //         }),
            //         //         offsetX: -12,
            //         //         offsetY: -18,
            //         //         font: 'bold 12px sans-serif',
            //         //         padding: [3, 6, 3, 6],
            //         //         textAlign: 'right',
            //         //         textBaseline: 'middle',
            //         //     }));
            //         // }
            //         // else{
            //         //     fst.setText(null);
            //         // }
            //         // }
            //         // f.setStyle(
            //         //     new Style({
            //         //         stroke: new Stroke({
            //         //             // color: "#0f44f6",
            //         //             color: carColor[aid],
            //         //             width: 4,
            //         //         }),
            //         //         // fill: new Fill({
            //         //         //     // color: "rgba(0, 255, 0, 1)",
            //         //         //     color: carColor[aid],
            //         //         // }),
            //         //         // image: new CircleStyle({
            //         //         //     radius: 8,
            //         //         //     stroke: new Stroke({
            //         //         //         color: "rgba(255, 255, 255, 0.5)",
            //         //         //         width: 4,
            //         //         //     }),
            //         //         //     fill: new Fill({
            //         //         //         // color: "#00ff00",
            //         //         //         // color: `rgba(${prop.image_color},1)`,
            //         //         //         color: carColor[aid],
            //         //         //     }),
            //         //         // }),
            //         //         text: dt_toolbar_buttons.label ? new Text({
            //         //             text: `${prop.car_name.toString()}`,
            //         //             fill: new Fill({
            //         //                 color: "rgba(255, 255, 255, 1)",
            //         //             }),
            //         //             stroke: new Stroke({
            //         //                 color: "rgba(0, 0, 0, 0.7)",
            //         //                 width: 2,
            //         //             }),
            //         //             backgroundFill: new Fill({
            //         //                 color: carColor[aid],
            //         //             }),
            //         //             offsetX: -12,
            //         //             offsetY: -18,
            //         //             font: 'bold 12px sans-serif',
            //         //             padding: [3, 6, 3, 6],
            //         //             textAlign: 'right',
            //         //             textBaseline: 'middle',
            //         //         }) : null
            //         //     })
            //         // );
            //     }
            //     // else{
            //     //     f.setStyle(styleCache[aid]);
            //     // }
            // });
        };

        const DT_fullView = () => {
            if( vectorLayer.value.getSource().getFeatures().length ){
                olMap.value.getView().fit(vectorLayer.value.getSource().getExtent());
                olMap.value.getView().setZoom(olMap.value.getView().getZoom() - 1);
            }
            else{
                olMap.value.getView().setCenter([48.4608285586, 40.3900191032]);
                olMap.value.getView().setZoom(8);
            }
        };

        const DT_customerView = () => {
            dt_toolbar_buttons.customer = !dt_toolbar_buttons.customer;
            customerLayer.value.setVisible( !customerLayer.value.getVisible() );
            if( dt_toolbar_buttons.customer ){
                getAllCustomers();
            }
            else{
                customerLayer.value.getSource().clear();
            }
        };

        const DT_removeFlashListener = () => {
            Object.entries(listenerKey).forEach(([key]) => {
                unByKey(listenerKey[key]);
                delete listenerKey[key];
            });
            dt_toolbar_buttons.flash = false;
        };

        const DT_flashLastPoint = () => {
            dt_toolbar_buttons.flash = true;
            // Object.entries(listenerKey).forEach(([key, val]) => {
            //     unByKey(listenerKey[key]);
            //     delete listenerKey[key];
            // });
            if( !Object.keys(listenerKey).length ){
                // DT_fullView();

                let a = {};
                let feas = {};
                let points = vectorCurPosLayer.value.getSource().getFeatures();
                points.forEach(f => {
                    let prop = f.getProperties();
                    if( !a[prop.car_id] ){
                        a[prop.car_id] = [];
                    }
                    a[prop.car_id].push(prop.pid);
                    feas[prop.pid] = f;
                });

                // if( points.length > 0 ){
                //     dt_toolbar_buttons.flash = true;
                // }

                // let b = {};
                // if( !selectedDevice.value ){
                    Object.entries(a).forEach(([key]) => {
                        // b[key] = Math.max(...a[key]);
                        let c = Math.max(...a[key]);
                        flash(feas[c]);
                    });
                // }
                // else{
                //     if( selectedDevice.value && a[selectedDevice.value.id] ){
                //         let c = Math.max(...a[selectedDevice.value.id]);
                //         flash(feas[c]);
                //     }
                // }
                a = null;
                feas = null;
                points = null;
            }
            else{
                DT_removeFlashListener();
            }
            // return b;
        };

        const DT_exToolView = () => {
            dt_toolbar_buttons.extool = !dt_toolbar_buttons.extool;
        };

        const DT_clearMap = () => {
            vectorLayer.value.getSource().clear();
            vectorLayerLine.value.getSource().clear();
            lineLength.value = 0;
            datepicker_start.value = '';
            datepicker_end.value = '';
            comboFilter.value = constComboLabel;
        };

        return {
            G, TR,
            getAllDevicePositions,
            getCurrentPositions,
            getPositionsByDeviceID,
            getPositionByDateInterval,
            infoTitle,
            showDetailInfo,
            showDetailInfoBody,
            cars,
            pointDetails,
            viewPoint,
            datepicker_start,
            datepicker_end,
            selectedDevice,
            constComboLabel,
            comboFilter,
            basemaps,
            basemapsLabel,
            changeBasemap,
            dt_toolbar_buttons,

            DT_showLabels,
            DT_fullView,
            DT_customerView,
            DT_flashLastPoint,
            DT_exToolView,
            DT_clearMap,
            lineLength,
        };
    },
};
</script>


<style lang="scss">
.map-div{
    // margin: 0 -12px;
    // margin: -4px;
    border: 0px;

    .popover {
        max-width: unset;
        // background-color: #1045F6;
        background-color: var(--primary-color);
        background: linear-gradient(110deg, var(--btn-primary) 22.16%, rgb(0, 175, 209) 76.47%) !important;
        border-radius: 25px;
    }

    .popover-header {
        padding-top: 1rem;
        background-color: transparent;
        border: 0px solid transparent;
        color: #fff;
    }

    .popover-header .popover-head-img {
        height: 80px;
        width: 90px;
        border: 4px solid white;
        border-radius: 15px;
    }

    .popover-body {
        background-color: #fff;
        border-radius: 23px;
    }

    .map-filter {
        max-height: 500px;
        overflow: auto;
        width: fit-content !important;
        min-width: 100%;
    }

    .device-info {
        bottom: 50px;
        left: 0.5em;
        max-height: 300px;
        width: calc(100% - 53px);
    }
    .footer-info {
        bottom: 0rem;
        left: 0rem;
        padding: .25rem .75rem;
        max-height: 300px;
        width: calc(100% - 59px);
        // border: 1px solid rgba(255, 255, 255, 0.07);
        background-color: rgba(var(--bs-dark-rgb), 0.8);
        height: 2.4em;
        align-items: center;
        display: grid;
    }

    th {
        font-weight: 600;
    }

    .calendarRange input{
        // width: 300px;
        // max-width: 100%;
        width: 145px !important;
        margin-right: 3px;
        padding: 0.6rem 0.1em 0.35em 0.75rem;
        border-radius: .25rem;
        border: 0 solid transparent;
        background-color: rgba(var(--bs-dark-rgb), 1) !important;
        color: rgba(var(--bs-white-rgb), 1) !important;
    }
    .calendarRange input:hover{
        background-color: rgba(var(--bs-dark-rgb), 0.9) !important;
    }

    .ol-zoom {
        top: auto;
        left: auto;
        // bottom: .4em;
        bottom: 0rem;
        right: .3rem;
    }
    .ol-zoom button {
        font-size: 1rem;
        height: 2.5rem;
        width: 2.5rem;
        // height: 2.2em;
        // width: 2em;
        // background-color: var(--bs-gray-900);
        // background-color: rgba(var(--bs-dark-rgb), 0.8);
        background-color: rgba(var(--main-rgb), 1);
        color: var(--bs-gray-400);
    }
    .ol-zoom button:hover,
    .ol-zoom button:focus {
        // background-color: var(--bs-gray-800);
        background-color: rgba(var(--main-rgb), .8);
        color: white;
    }

    .dropdown-item{
        color: #ffffff;
    }

    .ol-scale-line, .ol-scale-line-inner, .ol-scale-bar, .ol-scale-bar-inner, .ol-scale-step-marker{
        background-color: unset !important;
        position: unset !important;
        text-shadow: unset;
        color: #ffffff !important;
    }
    .ol-scale-line-inner{
        border: 1px solid #ffffff;
        border-top: none;
    }

    .ot-map-toolbar{
        position: absolute;
        bottom: 6rem;
        right: .4rem;
        z-index: 2;
    }

    .ot-map-toolbar button{
        display: block;
        // background-color: rgba(var(--bs-dark-rgb), 0.8);
        background-color: rgba(var(--main-rgb), 1);
        color: var(--bs-gray-400);
        border-radius: 1px;
        height: 2.5rem;
        width: 2.5rem;
        font-size: 1rem;
        // height: 2rem;
        // width: 1.85rem;
        margin-top: 1px;
        text-align: center;
        padding: 0.35rem 0.35rem !important;
        border: 0px;
    }
    .ot-map-toolbar button:hover{
        color: #ffffff !important;
    }

    .dropdown-toggle::after {
        display: none;
    }

    .infoWindow{
        width: 400px;
        height: 550px;
        overflow-y: auto;
    }

    .btn:hover {
        background-color: var(--bs-white);
    }

    @media (max-width: 576px) {
        .calendarRange input{
        opacity: 0;
        cursor: pointer;
        width: 40px !important;
        }
        .calendarRange{
            position: relative;
        }
        .calendarRange::before{
            content: "\f073";
            font-family: "Font Awesome 5 Free" !important;
            font-size: 0.8rem;
            position: absolute;
            top: 0;
            left: 0;
            background-color: var(--bs-dark);
            color: white;
            border: 1px solid transparent;
            padding: .375rem .75rem;
            border-radius: .25rem;
            border-top-left-radius: 0.25rem;
            border-bottom-left-radius: 0.25rem;
        }
        .footer-info{
            width: calc(100% - 58px);
        }
        .footer-info #map_scale{
            display: none;
        }
        .footer-powered{
            display: none;
        }

        .ol-zoom button {
            font-size: 1.5rem;
            height: 2.7rem;
            width: 2.7rem;
        }

        .ot-map-toolbar{
            bottom: 6.5rem;
            right: .4rem;
        }
        .ot-map-toolbar button{
            font-size: 1rem;
            height: 2.7rem;
            width: 2.7rem;
        }

        .device-info{
            width: calc(100% - 73px);
        }

        .infoWindow{
            width: calc( 100vw - 120px );
            height: calc( 100vw / 2 + 140px );
            overflow-y: auto;
        }
    }
}
</style>
